module.exports = __webpack_public_path__ + "static/img/shop-fallback-cats.f240be7a.png";